export default __webpack_public_path__ + "static/ui-71ecbf5eca5a0ef618e41f4a490cf6d2.webp";